import React, { useState } from "react";
import "../styles/WalletWithdraw.css";

const WalletWithdraw = ({ onClose, onSubmit, currentBalance }) => {
  const [mpesaNumber, setMpesaNumber] = useState("");
  const [confirmNumber, setConfirmNumber] = useState("");
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const isValidKenyanNumber = (number) => {
    const cleaned = number.replace(/\s+/g, "");
    return /^(07\d{8}|01\d{8}|2547\d{8})$/.test(cleaned);
  };

  const handleContinue = () => {
    const amountValue = parseFloat(amount);

    if (!isValidKenyanNumber(mpesaNumber)) {
      return setError("Please enter a valid Kenyan M-Pesa number.");
    }

    if (mpesaNumber.replace(/\s+/g, "") !== confirmNumber.replace(/\s+/g, "")) {
      return setError(
        "M-Pesa numbers do not match. Please check and try again.",
      );
    }

    if (isNaN(amountValue) || amountValue < 200) {
      return setError("Minimum withdrawal amount is KES 200.");
    }

    if (currentBalance < amountValue) {
      return setError("Insufficient wallet balance.");
    }

    setError("");
    setConfirming(true);
  };

  const handleConfirm = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await onSubmit({
        mpesaNumber,
        confirmMpesaNumber: confirmNumber,
        amount: parseFloat(amount),
      });

      if (res.status === "completed") {
        setSuccessMessage(
          `Withdrawal successful. M-Pesa Ref: ${res.transactionReference || "Sent"}`,
        );
      } else if (res.status === "failed") {
        setError(res.message || "Withdrawal failed.");
        setConfirming(false);
      } else {
        setSuccessMessage(
          "Withdrawal is processing. You will be notified shortly.",
        );
      }
    } catch (err) {
      setError(err.message || "Withdrawal failed.");
      setConfirming(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="withdraw-modal-overlay" onClick={onClose}>
      <div className="withdraw-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>

        <h3>Instant Withdrawal</h3>

        {error && <p className="error-message">{error}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        {!confirming && !successMessage && (
          <>
            <input
              type="text"
              placeholder="M-Pesa Number"
              value={mpesaNumber}
              onChange={(e) => setMpesaNumber(e.target.value)}
            />

            <input
              type="text"
              placeholder="Confirm M-Pesa Number"
              value={confirmNumber}
              onChange={(e) => setConfirmNumber(e.target.value)}
              onPaste={(e) => e.preventDefault()}
            />

            <input
              type="number"
              placeholder="Amount (KES)"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            <div className="withdraw-actions">
              <button className="withdraw-submit" onClick={handleContinue}>
                Continue
              </button>
              <button className="withdraw-cancel" onClick={onClose}>
                Cancel
              </button>
            </div>
          </>
        )}

        {confirming && !successMessage && (
          <>
            <div className="withdraw-confirmation">
              <p>
                <strong>Confirm Instant Withdrawal</strong>
              </p>
              <p>
                Amount: <b>KES {amount}</b>
              </p>
              <p>
                Number: <b>{mpesaNumber}</b>
              </p>
            </div>

            <div className="withdraw-actions">
              <button
                className="withdraw-submit"
                onClick={handleConfirm}
                disabled={loading}
              >
                {loading ? "Processing..." : "Confirm & Withdraw"}
              </button>
              <button
                className="withdraw-cancel"
                onClick={() => setConfirming(false)}
                disabled={loading}
              >
                Back
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WalletWithdraw;
